// eslint-disable-next-line import/prefer-default-export
export function triggerHapticClick() {
  // noop on non-native platforms
}
